<df-promo-banner *ngIf="!isLoggedIn() && bannerObj" id="promoBanner" [banner]="bannerObj"></df-promo-banner>

<app-alert></app-alert>

<!-- Dynamically ordered components -->
<ng-container *ngFor="let comp of orderedComponents">
  <app-banner *ngIf="comp.component === 'app-banner'"></app-banner>
  <app-pricing *ngIf="comp.component === 'app-pricing'"></app-pricing>
  <app-classes *ngIf="comp.component === 'app-classes'"></app-classes>
  <app-instructors *ngIf="comp.component === 'app-instructors'"></app-instructors>
  <app-training *ngIf="comp.component === 'app-training'"></app-training>
  <app-wellness *ngIf="comp.component === 'app-wellness'"></app-wellness>
  <app-video-widget *ngIf="comp.component === 'app-video-widget'"></app-video-widget>
</ng-container>

<!-- <app-social-media></app-social-media> -->

<app-location></app-location>

<df-download-app #download (click)="dlPopupClicked()"></df-download-app>
